// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table-page-search-wrapper[data-v-07b6ba86] {\n  margin-bottom: 16px;\n}\n.summary-info[data-v-07b6ba86] {\n  margin-bottom: 16px;\n  padding: 12px 16px;\n  background-color: #f0f2f5;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #333;\n}\n", ""]);
// Exports
module.exports = exports;
